import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ArrowDownIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9172 15.4657L6.62971 11.1782C6.29143 10.84 5.74298 10.84 5.40471 11.1782C5.06643 11.5165 5.06643 12.065 5.40471 12.4032L11.0851 18.0836C11.4756 18.4742 12.1088 18.4742 12.4993 18.0836L18.1797 12.4032C18.518 12.065 18.518 11.5165 18.1797 11.1782C17.8414 10.84 17.293 10.84 16.9547 11.1782L12.6672 15.4657V5.66574C12.6672 5.18249 12.2755 4.79074 11.7922 4.79074C11.309 4.79074 10.9172 5.18249 10.9172 5.66574V15.4657Z"
      />
    </Icon>
  );
};
